import { Component,OnInit,HostListener,Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from '../shared/services/webapi.service';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;
declare var bootstrap: any;
@Component({
  selector: 'app-series',
  templateUrl: './series.component.html',
  styleUrls: ['./series.component.scss']
})
export class SeriesComponent implements OnInit {
  series=[];
  totalseries = 0;
  playlistid='';
  index=0;
  page=1
  noSeries=false;
  categories=[]
  instructors=[]
  selectedcategory="";
  selectedinstructor="";
  videoDetails:any;
  keyword=''
  loggedin=false;
  trailerVideo="assets/videos/0b51970a-cd6d-4ec1-ba82-a714302fc23cKyle Pappas - Trailer.mp4";
  plan=null;
  constructor(@Inject(DOCUMENT) private document: Document,private toastrService: ToastrService, public webApi: WebapiService, private route: ActivatedRoute, public router: Router) {
    $(document).on('click','div[data-bs-target="#subscription-update-modal"]', function(e) {

        //get data-id attribute of the clicked element
        var msg = $(this).data('msg');
        //populate the textbox
        $('.sub-msg').html(msg);
        $('.sub-msg').addClass('mb-2');
    });
    $(document).on('click','.btn-close', function(e) {
      //populate the textbox
      $('.sub-msg').html("");
      $('.sub-msg').removeClass('mb-2');
    });
    
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (document.body.scrollTop > 100 ||     
    document.documentElement.scrollTop > 100) {
      document.getElementById('trans').classList.add('bg-dark');
    }else{
      document.getElementById('trans').classList.remove('bg-dark');
    }
  }

  ngOnInit(): void {
    this.loggedin=this.webApi.isLoggedIn();
    if(this.loggedin){
      this.getSeriesFilters()
      this.getSeries();
    }
  }

  search(){
    this.page=1
    this.series=[];
    this.getSeries()
  }
  reset() {
    this.page=1
    this.series=[];
    this.selectedinstructor=""
    this.selectedcategory=""
    if ($(".selectpicker").length != 0) {
      setTimeout( ()=> { 
          $('.selectpicker').selectpicker('refresh');  
      }, 500);  
    } 
    this.getSeries()
  }

  getStyles(seriesdata){
    if(seriesdata.background && seriesdata.background!=""){
      //console.log("bg",seriesdata.background);
      return "background: url('"+ this.getThumbUrl(seriesdata.background) +"') !important";
    }else{
      return "";
    }
  }

  getSeries(){
    this.noSeries = false;
    this.webApi.setLoader(true);
    let params= {
      "instructor":this.selectedinstructor,
      "category":this.selectedcategory,
      "keyword":this.keyword.trim(),
      "page":this.page
    }
    this.webApi.getSeries(params).subscribe((series: any) => {
      this.series = [...this.series,...series.data]; 
      this.plan=series.plan
      if(this.series.length==0){
        this.noSeries=true
      }

      this.totalseries = series.total; 
      this.webApi.setLoader(false);
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  getSeriesFilters(){
    this.webApi.getSeriesFilters().subscribe((data: any) => {
      if(data.success){
        this.categories = data.categories; 
        this.instructors = data.instructors; 
        if ($(".selectpicker").length != 0) {
          setTimeout( ()=> { 
              $('.selectpicker').selectpicker('refresh');  
          }, 500);  
        } 
      }else{
        this.toastrService.error("please reload the page");
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  showMore() {
    this.page = this.page+1
    this.getSeries();
  }
  
  getThumbUrl(url : string){
    return  "assets/images/"+url
  }

  getInstructorThumbUrl(url : string){
    return  "assets/instructors/"+url
  }

  login(){
    this.router.navigate(['/signup']);
  }

  seriesPlaylist(series){
    this.router.navigate(['/series/'+this.webApi.slugify(series.title)+'-'+series.id]);
  }

  openDetails(video,modalid:any){
    this.videoDetails = video
    
    setTimeout(function(){
      $('#'+modalid).modal('show');
    }, 100);
  }
}
